import { render, staticRenderFns } from "./LaraRedirection.vue?vue&type=template&id=a546e21e"
import script from "./LaraRedirection.vue?vue&type=script&lang=js"
export * from "./LaraRedirection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports